module.exports = __webpack_public_path__ + "img/s1v4.9b4a803a.jpg";